import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * Injects one or more JSON-LD objects into <head>. Pass a single object or
 * an array. Rendered as a <script type="application/ld+json"> per object so
 * react-snap serialises them into the prerendered HTML.
 */
export default function JsonLd({ data }) {
  const items = Array.isArray(data) ? data : [data];
  return (
    <Helmet>
      {items.map((obj, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(obj)}
        </script>
      ))}
    </Helmet>
  );
}
